import _ from 'lodash';

var white = `rgba(255, 255, 255, 1)`;
var black = `rgba(0, 0, 0, 1)`;

//good green - 9FC490, 84A59D
//good blue - 82A3A1
//good orange - F6BD60
//good pink - F5CAC3
var appsData = {
  admin: {
    localPort: 3021,
    style: {
      backgroundColor: '#F08',
      color: white
    }
  },
  checkout: {
    localPort: 3022,
    style: {
      backgroundColor: black,
      color: white
    }
  }
};

_.forEach(appsData, (appData, key) => {
  appData.key = key;
  appData.domain = process.env.NODE_ENV === 'development' ? `http://localhost:${appData.localPort}` : `https://${key}.henrybuilt.com`;

  if (!appData.title) appData.title = _.startCase(key);
});

export default appsData;
